export default __webpack_public_path__ + "static/5-projects-roof-repairs-698ae5ecaeb5a2ceb98fc0ce23dd1778.jpg";